/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wrapped_Muscles_EmptyInputs */

const en_us2_wrapped_muscles_empty = /** @type {(inputs: Wrapped_Muscles_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No set counted toward a target muscle this week.`)
};

const pt_br2_wrapped_muscles_empty = /** @type {(inputs: Wrapped_Muscles_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma série contou para um músculo-alvo nesta semana.`)
};

const es_419_wrapped_muscles_empty = /** @type {(inputs: Wrapped_Muscles_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ninguna serie contó para un músculo objetivo esta semana.`)
};

const pt_pt2_wrapped_muscles_empty = /** @type {(inputs: Wrapped_Muscles_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma série contou para um músculo-alvo esta semana.`)
};

const fr_fr2_wrapped_muscles_empty = /** @type {(inputs: Wrapped_Muscles_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune série n'a compté pour un muscle cible cette semaine.`)
};

const de_de2_wrapped_muscles_empty = /** @type {(inputs: Wrapped_Muscles_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Woche hat kein Satz für einen Zielmuskel gezählt.`)
};

const it_it2_wrapped_muscles_empty = /** @type {(inputs: Wrapped_Muscles_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna serie è contata per un muscolo principale questa settimana.`)
};

/**
* | output |
* | --- |
* | "No set counted toward a target muscle this week." |
*
* @param {Wrapped_Muscles_EmptyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_muscles_empty = /** @type {((inputs?: Wrapped_Muscles_EmptyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Muscles_EmptyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_muscles_empty(inputs)
	if (locale === "es-419") return es_419_wrapped_muscles_empty(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_muscles_empty(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_muscles_empty(inputs)
	if (locale === "de-DE") return de_de2_wrapped_muscles_empty(inputs)
	if (locale === "it-IT") return it_it2_wrapped_muscles_empty(inputs)
	return en_us2_wrapped_muscles_empty(inputs)
});
export { wrapped_muscles_empty as "wrapped.muscles_empty" }